import { createStyles, makeStyles } from '@material-ui/core/styles';

interface StyleProps {
  isMobile: boolean;
}

const useStyles = makeStyles(() =>
  createStyles({
    divSend: {
      padding: 10,
      width: ({ isMobile }: StyleProps) => (isMobile ? '382px' : '456px'),
    },
    divForm: {
      display: 'grid',
      justifyItems: 'center',
      justifyContent: ({ isMobile }: StyleProps) => (isMobile ? 'center' : 'space-between'),
      width: 'inherit',
    },
    labelSend: {
      fontFamily: 'SuraSans-Extranegrita',
      fontSize: '26px',
      color: '#000000',
    },
    card: {
      width: ({ isMobile }: StyleProps) => (isMobile ? '100%' : '456px'),
      height: '139px',
      background: '#FFFFFF',
      borderRadius: 20,
      margin: '20px 60px',
      padding: 20,
    },
    labelEmail: {
      color: '#0033A0',
      fontFamily: 'SuraSans-Negrita',
      fontSize: '15px',
    },
    textfield: {
      marginBottom: '30px',
      fontFamily: 'SuraSans-Regular',
      fontSize: '16px',
      '& label.Mui-focused': {
        color: '#2D6DF6',
      },
      '& .MuiInput-underline:after': {
        borderBottomColor: '#B4B4B5',
      },
    },
    input: {
      fontFamily: 'SuraSans-Regular',
      fontSize: '16px',
      color: '#000000',
      '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
        display: 'none',
      },
      '& input[type=number]': {
        MozAppearance: 'textfield',
      },
    },
    button: {
      width: '80px',
      height: '40px',
      borderRadius: 28,
      background: '#FFFFFF',
      border: '1px solid #0133A0',
      fontFamily: 'SuraSans-Seminegrita',
      fontSize: '16px',
      color: '#0133A0',
      marginLeft: '20px',
      alignItems: 'center',
    },
    divControl: {
      display: 'flex',
      alignItems: 'baseline',
      margin: '20px 0',
    },
    divButtonsOther: {
      width: ({ isMobile }: StyleProps) => (isMobile ? 'auto' : '936px'),
      display: ({ isMobile }: StyleProps) => (isMobile ? 'grid' : 'flex'),
      justifyContent: ({ isMobile }: StyleProps) => (isMobile ? 'center' : 'space-between'),
      padding: ({ isMobile }: StyleProps) => (isMobile ? '10px 0' : '0 20px'),
    },
    buttonPayOther: {
      fontFamily: 'SuraSans-Seminegrita',
      fontSize: '16px',
      color: '#2D6DF6',
      background: 'none',
      '&:hover': {
        background: 'none',
      },
    },
    buttonMoreSura: {
      width: '255px',
      height: '40px',
      border: '1px solid #0133A0',
      opacity: 1,
      borderRadius: 20,
      fontFamily: 'SuraSans-Seminegrita',
      fontSize: '16px',
      color: '#0133A0',
      background: 'none',
      '&:hover': {
        background: 'none',
      },
    },
    divider: {
      margin: '60px 0 20px 0 !important',
      width: '400px',
    },
    progress: {
      color: '#0133A0',
    },
  }),
);

export default useStyles;
